import React from 'react'

/**
 * Bottom-sheet filter UI for the phone inbox. Three chip groups:
 * Assigned to / Channel / Type. Selections are multi-select (per spec
 * D11). Apply button shows the count of tickets that would match.
 */

function ChipGroup({ label, options, selected, onToggle }) {
  return (
    <div className="filt-group">
      <div className="filt-group-label">{label}</div>
      <div className="filt-chips">
        {options.map(opt => (
          <button
            key={opt.value}
            className={`filt-chip ${selected.includes(opt.value) ? 'filt-chip--on' : ''}`}
            onClick={() => onToggle(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  )
}

function PhoneFilterSheet({ open, onClose, onApply, resultCount, value, setValue, options }) {
  if (!open) return null

  const toggle = (key, v) => {
    const current = value[key] || []
    const next = {
      ...value,
      [key]: current.includes(v) ? current.filter(x => x !== v) : [...current, v]
    }
    setValue(next)
  }

  return (
    <div className="filt-backdrop" onClick={onClose}>
      <div
        className="filt-sheet"
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-label="Ticket filters"
      >
        <div className="filt-grip" aria-hidden />
        <h2 className="filt-h">Filters</h2>
        <ChipGroup
          label="Assigned to"
          options={options.assignees || []}
          selected={value.assignees || []}
          onToggle={v => toggle('assignees', v)}
        />
        <ChipGroup
          label="Channel"
          options={options.channels || []}
          selected={value.channels || []}
          onToggle={v => toggle('channels', v)}
        />
        <ChipGroup
          label="Type"
          options={options.types || []}
          selected={value.types || []}
          onToggle={v => toggle('types', v)}
        />
        <button className="filt-apply" onClick={onApply}>
          Apply{typeof resultCount === 'number' ? ` (showing ${resultCount})` : ''}
        </button>
      </div>
    </div>
  )
}

export default PhoneFilterSheet
